var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnboardingComplete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00004 14.6668C11.6819 14.6668 14.6667 11.6821 14.6667 8.00016C14.6667 4.31826 11.6819 1.3335 8.00004 1.3335C4.31814 1.3335 1.33337 4.31826 1.33337 8.00016C1.33337 11.6821 4.31814 14.6668 8.00004 14.6668ZM11.0893 6.92275C11.4147 6.59731 11.4147 6.06968 11.0893 5.74424C10.7639 5.4188 10.2362 5.4188 9.91078 5.74424L7.16671 8.48832L6.0893 7.41091C5.76386 7.08547 5.23622 7.08547 4.91079 7.41091C4.58535 7.73634 4.58535 8.26398 4.91079 8.58942L6.57745 10.2561C6.90289 10.5815 7.43053 10.5815 7.75596 10.2561L11.0893 6.92275Z",
    fill: "#3A836C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingComplete);
export default __webpack_public_path__ + "static/media/onboarding-complete.a784bed4a610e910f726f79b80250871.svg";
export { ForwardRef as ReactComponent };